import React from 'react';
import { Layout } from '../components'

const NoMatch = () => (
  <Layout>
    <h1>The page doesn't exist</h1>
    <p>Please contact us if you think that is a bug.</p>
  </Layout>
)

export default NoMatch;
